import {Component} from '@angular/core';

@Component({
    selector: 'app-terms-and-condition',
    templateUrl: './terms-and-condition.component.html',
    styleUrl: './terms-and-condition.component.css'
})
export class TermsAndConditionComponent {

}
